import { render, staticRenderFns } from "./WorkerActionsPageDropdown.vue?vue&type=template&id=48833b00&scoped=true&"
import script from "./WorkerActionsPageDropdown.vue?vue&type=script&lang=js&"
export * from "./WorkerActionsPageDropdown.vue?vue&type=script&lang=js&"
import style0 from "./WorkerActionsPageDropdown.vue?vue&type=style&index=0&id=48833b00&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48833b00",
  null
  
)

export default component.exports